import * as React from 'react';
import * as styles from './styles.scss';
import { ProjectIdProvider } from 'owa-timestream-asset-sdk';
import type { AssetDescriptor } from 'owa-timestream-asset-sdk-types';
import { Draggable } from 'owa-dnd';
import { getZoom } from '../viewstate';
import { observer } from 'mobx-react-lite';
import { render } from 'react-dom';
import { useGetAssetDragData } from '../util/assetDragAndDrop';
import { TimeStreamToolboxButton } from 'owa-timestream-toolbox-common';
import { getSelectedProjectId } from 'owa-timestream-store';
import { Fabric } from '@fluentui/react/lib/Fabric';
import { useCreateAssetCallback } from '../hooks/useCreateAssetCallback';

export default observer(function TimeStreamAssetTool({
    assetDescriptor,
    isOverflowTool,
}: {
    assetDescriptor: AssetDescriptor;
    isOverflowTool?: boolean;
}) {
    const {
        iconName,
        iconNameRTL,
        getToolName,
        getTooltip,
        createEmptyAsset,
        CanvasView,
    } = assetDescriptor;
    const getDragData = useGetAssetDragData(assetDescriptor, 'Toolbar');

    const getDragPreview = React.useCallback(() => {
        const elem = document.createElement('div');
        const emptyAsset = createEmptyAsset();
        elem.className = styles.assetView;
        elem.style.transformOrigin = '0 0 0';
        elem.style.transform = 'scale(' + getZoom().toString() + ')';
        elem.style.backgroundColor = 'var(--white)';
        elem.style.overflow = 'hidden';
        if (emptyAsset.width) {
            elem.style.width = `${emptyAsset.width}px`;
        }
        if (emptyAsset.height) {
            elem.style.height = `${emptyAsset.height}px`;
        }
        render(
            <Fabric>
                <ProjectIdProvider value={getSelectedProjectId()}>
                    <CanvasView payload={emptyAsset.payload} isDragPreview={true} />
                </ProjectIdProvider>
            </Fabric>,
            elem
        );
        return elem;
    }, [CanvasView, createEmptyAsset]);

    const { onClick } = useCreateAssetCallback(assetDescriptor, 'ToolbarClick');

    return (
        <Draggable
            classNames={styles.draggableAsset}
            getDragData={getDragData}
            getDragPreview={getDragPreview}>
            <TimeStreamToolboxButton
                iconName={iconName}
                iconNameRTL={iconNameRTL}
                getToolName={getToolName}
                getTooltip={getTooltip}
                showTitle={isOverflowTool}
                isDraggable={true}
                onClick={onClick}
            />
        </Draggable>
    );
});
